import { Directive, ElementRef, HostListener } from '@angular/core';
@Directive({
    selector: '[ngxWholeNumber]',
    standalone: false
})
export class NgxWholeNumberDirective {
  private regex: RegExp = new RegExp(/^\d*$/g);
  private specialKeys: Array<string> = [
    'Backspace',
    'Tab',
    'End',
    'Home',
    '-',
    'ArrowLeft',
    'ArrowRight',
    'Del',
    'Delete',
  ];
  constructor(private el: ElementRef) {}
  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    // Allow Backspace, tab, end, and home keys
    if (this.specialKeys.indexOf(event.key) !== -1) {
      return;
    }
    const next: string = event.key;

    if (next && !String(next).match(this.regex)) {
      event.preventDefault();
    }
  }
}
